import type { HeaderBaseProps } from "./factory-header.types"
import { SiteHeader } from "./site-header"

export function BaseHeaderNoCloseBtn({ homePageLogoLink }: HeaderBaseProps) {
  return <SiteHeader>{homePageLogoLink}</SiteHeader>
}
